const styles = theme => ({
  paperCardFrame: {
    marginBottom: '24px',
  },
  title: {
    fontWeight: '600',
    marginBottom: '5px',
  },
  titleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    [theme.breakpoints.up('md')]: {
      borderBottom: '1px solid #CED1D6',
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '16px',
      '& $dangerText': {
        color: '#D2374F',
      },
      '& $textDanger': {
        color: theme.palette.primary.main,
      },
    },
    '& $textGray': {
      fontSize: '14px',
      marginTop: '6px',
    },
    '& $textRight': {
      fontSize: '20px',
      fontWeight: '600',
    },
  },
  textDanger: {},
  textRight: {
    marginLeft: 'auto',
  },
  titleHeadActions: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    '& button': {
      '& > span > p': {
        color: theme.palette.primary.main,
        fontWeight: 600,
        textTransform: 'none',
      },
    },
    '& > span': {
      margin: '0px 4px',
    },
  },
  headsubtitle: {
    marginLeft: 'auto',
    fontSize: '12px',
    fontWeight: '500',
  },
  innerCard: {
    padding: '12px 16px',
  },
  innerCardNoPadding: {
    padding: '0px',
  },
  inputGridContainer: {
    width: '100%',
    padding: '16px',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gridTemplateRows: 'auto',
    columnGap: '10px',
    rowGap: '20px',
    alignItems: 'start',
  },
  gridFullWidth: {
    gridColumn: '1 /  3',
  },
  largeButton: {
    height: '36px',
    border: '1px solid #342D3D',
    alignItems: 'center',
    '& img': {
      marginRight: '8px',
      width: '12px',
      height: '12px',
    },
    '& p': {
      fontSize: '12px',
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  horizontalRadio: {
    flexDirection: 'row',
    color: theme.palette.secondary.light,
    '& input:checked + div': {
      color: theme.palette.primary.main,
    },
    '& svg': {
      height: '28px',
      width: '28px',
    },
    '& span': {
      fontSize: '16px',
    },
  },
  radio: {
    marginRight: '40px',
  },
  fetchTextField: {
    display: 'grid',
    gridTemplateColumns: '10fr 2fr',
    columnGap: '10px',
    marginBottom: '8px',
    alignItems: 'flex-end',
    '& button': {
      background: theme.palette.primary.acscent,
      padding: '0.8em',
      height: '53px',
      borderRadius: '0px',
      textTransform: 'none',
      minWidth: '114px',
    },
  },
  infoAlert: {
    color: theme.palette.primary.adgmInfo,
    fontSize: '14px',
    '& img': {
      marginRight: '4px',
    },
  },
  mediumButton: {
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    padding: '1em 3em',
    '&:disabled': {
      backgroundColor: `${theme.palette.primary.black20} !important`,
      color: `${theme.palette.primary.white} !important`,
    },
  },
  calculatedField: {
    '& .MuiOutlinedInput-root': {
      background: theme.palette.primary.borderColor,
    },
  },
  calendarTextfieldIcon: {
    marginRight: '10px',
    cursor: 'pointer',
  },
  fileFlex: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '12px 0px',
    '& img': {
      marginRight: '12px',
    },
    '& button': {
      marginLeft: 'auto',
      textTransform: 'none',
      color: 'grey',
    },
  },
  textDim: {
    color: theme.palette.primary.dim,
  },
  textADGMRed: {
    color: theme.palette.primary.main + '!important',
  },
  textADGMGreen: {
    color: theme.palette.primary.adgmGreen + '!important',
  },
  textGrayLight: {
    color: theme.palette.primary.darkGrey,
  },
  adgmSelect: {
    '& p': {
      maxWidth: '220px',
    },
  },
  formControl: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '0',
    '& + $formControl': {
      paddingTop: '15px',
    },
  },
  fieldInfo: {
    marginTop: '6px',
    fontWeight: 'normal',
  },

  // Buyer details styles
  buyerModalPerson: {
    top: '50%',
    height: '84%',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  panelTitle: {
    padding: '10px 24px',
    background: theme.palette.primary.grey,
    border: '1px solid #CED1D6',
    borderRight: 'none',
    borderLeft: 'none',
    '& h6': {
      fontSize: '20px',
    },
  },
  subPanel: {
    padding: '10px 24px',
  },
  infoAlertBorder: {
    paddingBottom: '12px',
    borderBottom: '1px solid #EBEEF3',
  },
  modalFooter: {
    borderTop: '1px solid #EBEEF3',
    marginTop: '30px',
    textAlign: 'right',
  },
  addBuyerButton: {
    background: theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      color: '#000',
    },
  },
  docsContainer: {
    marginTop: '10px',
    width: '100%',
  },
  buyerDoc: {
    '& $expandedAccordian': {
      borderBottom: '6px solid #EBEEF3',
    },
    '& $accordianTitle': {
      padding: '0px 24px',
      border: 'none',
      borderBottom: '1px solid #EBEEF3',
      minHeight: '60px',
      display: 'flex',
      alignItems: 'center',
      '& p': {
        marginTop: '2px',
        marginLeft: '10px',
        fontWeight: 600,
        fontSize: '16px',
        '& span:last-child': {
          color: theme.palette.primary.main,
        },
      },
      '& > div': {
        margin: 0,
      },
    },
    '& $accordionDetails': {
      width: '100%',
      padding: '24px',
    },
    '&:last-child': {
      '& $expandedAccordian': {
        borderBottom: 'none',
      },
    },
  },
  buyerSummaryContainer: {
    '& $buyerDetails': {
      padding: '20px',
    },
    '& $buyerInfoText': {
      color: theme.palette.primary.acscent,
      fontWeight: 600,
      fontSize: '18px',
    },
  },
  loader: {},
  accordianTitle: {},
  accordionDetails: {},
  buyerDocAccordian: {},
  expandedAccordian: {},
  addedBuyerFile: {},
  buyerDetails: {},
  buyerInfoText: {},
  docsFlexContainer: {
    transition: 'all 1s',
    width: '100%',
    '& $addedBuyerFile': {
      marginBottom: '0px !important',
    },
    '& $fileFlex': {
      padding: '4px 0px',
      '& p': {
        fontSize: '12px',
      },
      '& img': {
        width: '20px',
        height: '20px',
      },
      '& button': {
        fontSize: '12px',
        fontWeight: 400,
        flexShrink: '0',
      },
    },
  },

  // Selling percentage
  agreementDetailsinnerCard: {
    color: '#342D3D',
    '& $innerframe': {
      borderTop: '1px solid #EBEEF3',
      padding: '20px 0px',
      '&:first-child': {
        paddingTop: '0',
        borderTop: '0',
      },
      '&:last-child': {
        padding: '20px 0px 0px 0px',
      },
    },
    '& $graysubtitle': {
      color: '#565960',
      marginBottom: '15px',
    },
    '& $CheckboxHolder': {
      '& label': {
        '& span': {
          fontSize: '18px',
        },
      },
      '& input:checked + svg': {
        color: '#1FCACC',
      },
      '& input:checked + div': {
        color: theme.palette.primary.main,
      },
    },
    '& $CheckboxcheckedHolder': {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
    },
    '& $cardContent': {
      paddingTop: '0px',
      paddingBottom: '0px',
      paddingLeft: '0px',
    },
  },
  innerframe: {},
  CheckboxHolder: {},
  graysubtitle: {},
  CheckboxcheckedHolder: {},
  cardContent: {},
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    '& $ownerAvatarimg': {
      marginRight: '16px',
      height: '64px',
      width: '64px',
      background: '#EBEEF3',
    },
    '& $sellerName': {
      color: theme.palette.primary.acscent,
      fontWeight: 600,
      fontSize: '18px',
    },
    '& $sellerNameMute': {
      color: theme.palette.primary.darkGrey,
    },
    '& $brokerTextHolder': {
      '& $buyerNumber': {
        color: theme.palette.primary.dim,
      },
      '& $buyerName': {
        color: theme.palette.primary.acscent,
        fontSize: '18px',
        fontWeight: 600,
      },
    },
  },
  ownerAvatarimg: {},
  sellerName: {},
  sellerNameMute: {},
  brokerTextHolder: {},
  buyerNumber: {},
  buyerName: {},
  addSellerButton: {
    marginLeft: 'auto',
    flexShrink: '0',
    background: theme.palette.primary.acscent,
    borderRadius: '0px',
    color: theme.palette.primary.white,
    minWidth: '163px',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'none',
    '&:hover': {
      background: '#28242d',
    },
  },
  addSellerButtonMute: {
    background: 'none',
    color: theme.palette.primary.acscent,
    border: '1px solid' + theme.palette.primary.acscent,
    '&:hover': {
      color: theme.palette.primary.white,
    },
  },
  sellingPercentageFrame: {
    paddingTop: '20px',
    '& $textField': {
      display: 'flex',
      alignItems: 'flex-end',
      flexWrap: 'wrap',
      '& $discountText': {
        marginBottom: '13px',
        paddingLeft: '16px',
        color: '#8C9099',
        fontWeight: '500',
      },
      '& $remainingTextArea': {
        '& $discountText': {
          marginBottom: '3px',
        },
      },
    },
    '& $adgmTextField': {
      maxWidth: '168px',
    },
    '& $sellerCheckbox': {
      marginTop: '4px',
      '& $checkbox': {
        color: 'inherit',
      },
      '& $checkboxChecked': {
        color: theme.palette.primary.adgmGreen + '!important',
      },
      '& $checkboxLabel': {
        fontSize: '16px',
        color: theme.palette.primary.acscent,
        fontWeight: 500,
      },
    },
  },
  textField: {},
  remainingTextArea: {},
  discountText: {},
  sellerCheckbox: {},
  checkBox: {},
  checkboxChecked: {},
  checkboxLabel: {},
  adgmTextField: {
    alignItems: 'stretch',
    '& > div': {
      alignItems: 'stretch',
      paddingRight: '0',
    },
    '& fieldset': {
      border: '1px solid #CED1D6',
      borderRadius: '0px',
    },
  },
  percentageAdornment: {
    borderLeft: '1px solid #CED1D6',
    maxHeight: '100%',
    paddingLeft: '16px !important',
    alignItems: 'center',
    '& p': {
      color: '#CED1D6',
      fontSize: '23px',
      fontWeight: '600',
    },
  },

  // Documents step styles
  docAccordianFrame: {
    [theme.breakpoints.up('md')]: {
      border: '1px solid #CED1D6',
      borderRadius: '0px 10px 0 0 !important',
    },
    margin: ' 0 0 5px !important',
    overflow: 'hidden',
    color: '#342D3D',
    '&:before': {
      background: 'transparent',
      display: 'none',
    },
  },
  expandedDocAccordianFrame: {
    [theme.breakpoints.up('md')]: {
      borderRadius: '0px !important',
    },
  },
  docAccordionTitleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    padding: '4px 15px',
    '& > div': {
      margin: '0 !important',
    },
    '& $docAccordionHeading': {
      fontSize: '16px',
      fontWeight: '600',
    },
    '& svg': {
      color: '#342D3D',
      fontSize: '27px',
    },
  },
  docAccordionHeading: {},
  docAccordianDetails: {
    padding: '0px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& $docChildAccordion': {
      width: '100%',
    },
    '& $docChildExpandeddAccordion': {
      borderBottom: '6px solid #EBEEF3',
      margin: '0px',
      '&:last-child': {
        borderBottom: 'none !important',
      },
    },
    '& $lastDocChildExpandeddAccordion': {
      borderBottom: 'none !important',
      margin: '0px',
    },
    '& $docChildAccordionTitleHead': {
      padding: '4px 15px',
      border: 'none',
      borderBottom: '1px solid #EBEEF3',
      minHeight: '60px',
      display: 'flex',
      alignItems: 'center',
      '& p': {
        marginTop: '2px',
        marginLeft: '10px',
        fontWeight: 600,
        fontSize: '14px',
        '& $mandatory': {
          color: theme.palette.primary.main,
        },
      },
      '& img': {
        height: '20px',
        width: '20px',
      },
      '& > div': {
        margin: '0 !important',
      },
      '& svg': {
        color: '#342D3D',
        fontSize: '27px',
      },
    },
    '& $docChildAccordianDetails': {
      padding: '16px 15px',
    },
  },
  docChildAccordion: {},
  docChildExpandeddAccordion: {},
  lastDocChildExpandeddAccordion: {},
  docChildAccordionTitleHead: {},
  mandatory: {},
  docChildAccordianDetails: {},

  // Power of Attorney
  hidden: {
    display: 'none',
  },
  poaTitleHead: {
    '& $titleAction': {
      padding: '0px',
      marginLeft: 'auto',
      cursor: 'pointer',
      background: 'none',
      '& p': {
        color: theme.palette.primary.main,
        fontWeight: 'normal',
        textTransform: 'none',
      },
      '&:hover': {
        opacity: 0.8,
      },
    },
  },
  titleAction: {},

  // PoA Styles
  poaList: {
    '& $poaListItem': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '18px 24px',
      borderBottom: '1px solid #EBEEF3',
      '&:last-child': {
        borderBottom: 'none',
      },
      '& > div:first-child': {
        display: 'flex',
        alignItems: 'center',
      },
      '& > div:last-child button': {
        minWidth: '12rem',
        background: theme.palette.primary.adgmBlack,
        color: '#FFFFFF',
        textTransform: 'none',
        paddingLeft: '3rem',
        paddingRight: '3rem',
        fontSize: '14px',
        fontWeight: 600,
        borderRadius: '0px',
        '& $listItemBtnIcon': {
          color: 'white',
        },
      },
    },
    '& $poaAvatar': {
      height: '64px',
      width: '64px ',
    },
    '& $poaListItemText': {
      color: theme.palette.primary.adgmBlack,
      fontSize: '18px',
      fontWeight: 600 + ' !important',
      padding: '0px 8px',
    },
    '& $poaListItemTextSecondary': {
      color: theme.palette.primary.dim,
      fontSize: '16px',
      fontWeight: 'normal !important',
    },
    '& $poaDetails': {
      padding: '20px 40px',
      borderBottom: '1px solid #EBEEF3',
      '& $poaDetailsHead': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        '& > p': {
          fontSize: '18px',
          fontWeight: 500,
          color: theme.palette.primary.adgmBlack,
        },
      },
      '& $poaDetailsGrid': {
        display: 'grid',
        rowGap: '1em',
        columnGap: '1em',
        marginTop: '10px',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 30%))',
        '& > div': {
          padding: '10px 0px',
          '& > p:first-child': {
            fontSize: '16px',
            color: theme.palette.primary.dim,
            lineHeight: '24px',
          },
          '& > p:last-child': {
            fontSize: '18px',
            color: '#484456',
            lineHeight: '27px',
          },
        },
      },
    },
  },
  poaListItem: {},
  poaAvatar: {},
  poaListItemText: {},
  poaListItemTextSecondary: {},
  listItemBtnIcon: {},
  poaDetails: {},
  poaDetailsHead: {},
  poaDetailsGrid: {},
  poaDetailsHeadActions: {},

  '@media (max-width: 645px)': {
    inputGridContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      '& > div': {
        width: '100%',
      },
    },
    fetchTextField: {
      gridTemplateColumns: '9fr 3fr',
      columnGap: '6px',
    },

    // Buyer details styles
    buyerSummaryContainer: {
      '& $buyerInfoText': {
        fontWeight: 600,
        fontSize: '14px',
      },
    },
    panelTitle: {
      '& h6': {
        fontSize: '16px',
      },
    },
    accordianTitle: {
      '& p': {
        fontSize: '14px !important',
      },
    },
  },
  '@media (max-width:767px)': {
    paperCardFrame: {
      border: '0',
      borderRadius: '0',
    },
    titleHead: {
      flexWrap: 'wrap',
      '& $textRight': {
        fontSize: '16px',
      },
    },
    formControl: {
      gap: '16px',
    },

    // Buyer details styles
    buyerModalPerson: {
      top: '0%',
      height: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
    },

    // Selling percentage
    agreementDetailsinnerCard: {
      '& $CheckboxHolder': {
        '& label': {
          '& span': {
            fontSize: '14px',
          },
        },
      },
      '& $graysubtitle': {
        fontSize: '14px',
      },
    },
    flexCenter: {
      flexWrap: 'wrap',
      '& $ownerAvatarimg': {
        marginRight: '10px',
        height: '44px',
        width: '44px',
        background: '#EBEEF3',
      },
      '& $sellerName': {
        color: theme.palette.primary.acscent,
        fontWeight: 600,
        fontSize: '14px',
      },
      '& $addSellerButton': {
        width: '100%',
        marginTop: '16px',
      },
      '& $brokerTextHolder': {
        '& $buyerNumber': {
          fontSize: '14px',
        },
        '& $buyerName': {
          fontSize: '14px',
        },
      },
    },
    sellingPercentageFrame: {
      '& $textField': {
        '& $discountText': {
          fontSize: '12px',
          paddingLeft: '12px',
        },
      },
      '& $adgmTextField': {
        alignItems: 'stretch',
        '& > div': {
          maxHeight: '50px',
          fontSize: '12px',
        },
        '& fieldset': {
          border: '1px solid #CED1D6',
          borderRadius: '0px',
        },
      },
      '& $percentageAdornment': {
        maxHeight: '50px',
        paddingLeft: '16px !important',
        '& p': {
          color: '#CED1D6',
          fontSize: '20px',
          fontWeight: '600',
        },
      },
      '& $sellerCheckbox': {
        '& $checkboxLabel': {
          fontSize: '14px',
          fontWeight: 400,
        },
      },
    },

    // Documents step styles
    docAccordionTitleHead: {
      minHeight: '48px !important',
      '& > div': {
        padding: '0',
      },
    },
    docChildAccordionTitleHead: {
      minHeight: '48px !important',
      '& > div': {
        padding: '0',
      },
    },

    // PoA Styles
    poaList: {
      '& $poaListItem': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '16px',
        '& > div:last-child': {
          width: '100%',
          marginTop: '12px',
          '& button': {
            width: '100%',
          },
        },
      },
      '& $poaAvatar': {
        height: '40px',
        width: '40px ',
      },
      '& $poaListItemText': {
        fontSize: '14px',
      },
      '& $poaListItemTextSecondary': {
        fontSize: '14px',
      },
      '& $poaDetails': {
        padding: '20px 0px',
        '& $poaDetailsHead': {
          padding: '0px 16px',
          '& > p': {
            fontSize: '14px',
          },
          '& $poaDetailsHeadActions': {
            '& > span': {
              margin: '0px',
            },
            '& button': {
              paddingLeft: '0px',
              paddingRight: '0px',
              '& > span': {
                '& > span': {
                  marginLeft: '0px',
                  marginRight: '4px',
                },
              },
            },
            '& img': {
              width: '12px',
              height: '12px',
            },
            '& p': {
              fontSize: '12px',
            },
          },
        },
        '& $poaDetailsGrid': {
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(100%, 30%))',
          '& > div': {
            padding: '0px 16px 10px 16px',
            borderBottom: '1px solid #EBEEF3',
            '& > p:first-child': {
              fontSize: '14px',
            },
            '& > p:last-child': {
              fontSize: '14px',
              lineHeight: '20px',
            },
            '&:last-child': {
              borderBottom: 'none',
            },
          },
        },
      },
    },
  },
  '@media (min-width: 768px)': {
    inputGridContainer: {
      padding: '16px 24px',
    },
    titleHead: {
      padding: '16px 24px',
      '& h1': {
        fontSize: '20px',
      },
    },
    headsubtitle: {
      fontSize: '16px',
      fontWeight: '400',
    },
    largeButton: {
      height: '60px',
      minWidth: '228px',
      borderRadius: '0px',
      border: '1.36111px solid #342D3D',
      '& img': {
        width: '17px',
        height: '17px',
      },
      '& p': {
        fontSize: '16px',
      },
    },
    formControl: {
      gap: '16px',
    },
    docsFlexContainer: {
      '& $fileFlex': {
        padding: '12px 0px',
        '& p': {
          fontSize: '14px',
        },
        '& img': {
          width: '32px',
          height: '32px',
        },
        '& button': {
          fontSize: '14px',
          fontWeight: 500,
        },
      },
    },

    // Documents step styles
    docAccordianFrame: { margin: '0 0 16px !important' },
    docAccordionTitleHead: {
      padding: '4px 24px',
      '& $docAccordionHeading': {
        fontSize: '20px',
      },
      '& svg': {
        fontSize: '27px',
      },
    },
    docChildAccordionTitleHead: {
      padding: '4px 24px !important',
      '& p': {
        fontSize: '16px !important',
      },
      '& img': {
        height: '32px !important',
        width: '32px !important',
      },
    },
    docChildAccordianDetails: {
      padding: '20px 24px !important',
    },
  },
  '@media (min-width: 992px)': {
    innerCard: {
      padding: '24px',
    },
    innerCardNoPadding: {
      padding: '0px',
    },
    formControl: {
      gridTemplateColumns: '1fr 1fr',
    },
  },
});

export default styles;
